import {CheckCircleIcon} from "@heroicons/react/24/solid";
import {useContext} from "react";
import {OscarContext, OscarContextType} from "@/components/context/OscarContext.tsx";
import BrandLogo from "@/components/ui/BrandLogo.tsx";
import {Button} from "@/components/ui/button.tsx";

export function CommunityBookingConfirmation() {
    const { brandConfig } = useContext(OscarContext) as OscarContextType

    return (
        <div className={"os-app-row os-flex os-flex-col os-items-center"}>
            <CheckCircleIcon className="os-text-green-500 os-h-24 os-w-24 os-mb-4"/>
            <p className={"os-text-2xl os-text-center os-mb-4"}>Booking Request!</p>
            <p className={"os-text-center"}>Thank you for booking with {brandConfig?.name ?? 'us'}, we have received your request and will process your booking as soon as possible.</p>
            <p className={"os-text-center"}>If you have any questions please call us on <a href={`tel:`+brandConfig?.phoneUrl} className="os-text-blue-500">{ brandConfig?.phone }</a></p>
            <BrandLogo className="os-w-12 os-h-12 os-mt-4"/>

            <Button className="os-mt-4" onClick={() => window.location.reload()}>Book Another Bin?</Button>
        </div>
    );
}